<template>
    <div class="sustainable-component admin-company" style="position:relative;">
        <!--<div class="bg-success mb-3 p-3 rounded">vue admin-company-department</div>-->
        <div class="container-fluid p-0 mt-3">
            <div class="row px-3">
                <div class="col-12 p-0">
                    <CommonLabelContainer title="Skapa företag" class="mt-5 mb-3">
                        <v-form v-model="valid" ref="form">
                            <div class="container-fluid p-0">
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <v-text-field bg-color="white"
                                                      :rules="[rules.required]"
                                                      name="CompanyName"
                                                      id="CompanyName"
                                                      type="text"
                                                      label="Företagsnamn"
                                                      variant="outlined"
                                                      v-model="company.Name"
                                                      focused="true"></v-text-field>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="container-fluid p-0">
                                            <div class="row">
                                                <div class="col">
                                                    <v-select name="Club" v-model="company.ClubId" item-title="ClubName" item-value="ClubId" :items="getClubs()" label="Klubb">

                                                    </v-select>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <v-select name="WorkSpace" v-model="company.WorkspaceId" item-title="WorkspaceName" item-value="WorkspaceId" :items="getWorkspaces()" label="Arbetsplats">

                                                    </v-select>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <v-select name="UserId" v-model="company.UserId" item-title="Username" item-value="UserId" :items="getUsers()" label="Användare">

                                                    </v-select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <v-btn variant="tonal" @click="createCompany" class="bg-primary">
                                            Skapa
                                        </v-btn>
                                        <ExampleCompanyMenu class="ms-2"
                                                            :items="availableExampleCompanies"
                                                            @select="createExampleCompany"></ExampleCompanyMenu>
                                    </div>
                                </div>
                            </div>
                        </v-form>
                    </CommonLabelContainer>
                </div>
            </div>
            <div class="row table-space p-3">
                <b>Visar {{companies.length}} företag</b>
                <div class="mt-3">
                    <v-text-field @change="loadCompanies" bg-color="white"
                                  name="FilterCompanyName"
                                  id="FilterCompanyName"
                                  type="text"
                                  label="Filtrera på företagsnamn, email eller avdelningsnamn"
                                  variant="outlined"
                                  v-model="filter"
                                  focused="true"></v-text-field>
                </div>
                <table class="mt-2 table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                    <thead>
                        <tr>
                            <th class="col-2">Namn</th>
                            <th class="col-2">Status</th>

                            <th class="col-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in getCompanies()" :key="index">
                            <td>{{item.Name}}</td>
                            <td>{{item.Status}}</td>

                            <td valign="middle">
                                <div class="pull-right" style="">
                                    <div class="dropdown text-right pr-2">
                                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                            ...
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a href="javascript:void(0)" class="dropdown-item" @click="updateCompany(item)">Ändra</a>
                                            <a href="javascript:void(0)" class="dropdown-item" @click="copyCompany(item)">Kopiera</a>
                                            <a href="javascript:void(0)" class="dropdown-item" @click="deleteCompany(item.CompanyId)">Ta bort permanent</a>
                                            <a v-if="item.IntStatus == 10" href="javascript:void(0)" class="dropdown-item" @click="setCompanyDeleted(item.CompanyId)">Markera som borttagen</a>
                                            <a v-if="item.IntStatus == 30" href="javascript:void(0)" class="dropdown-item" @click="reactivateCompany(item.CompanyId)">Återaktivera</a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <AdminUpdateCompanyDepartment ref="updateCompanyModal" @updated="loadCompanies"></AdminUpdateCompanyDepartment>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>
    import ValidationService from "../../Services/ValidationService";
    import AdminService from "../../Services/AdminService";
    import CommonLabelContainer from "../../common/common-label-container";
    import AdminUpdateCompanyDepartment from './update/update-company-department.vue'
    import ExampleCompanyMenu from './common/example-company-menu.vue'
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'
    const form = ref(null);
    const updateCompanyModal = ref(null);
    export default {

        name: 'admin-company-department',
        props: {

        },
        components: {
            CommonLabelContainer,
            AdminUpdateCompanyDepartment,
            ExampleCompanyMenu,
            CommonSpinner
        },
        methods: {
            async createCompany() {
                this.loading++;
                try{
                    await AdminService.createCompany(this.company);
                    this.displaySnackBar("Bolaget skapades");
                    this.loadCompanies();
                    window.refreshCompanies()
                }
                catch(error){
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async createExampleCompany(item) {
                this.loading++;
                try {
                    await AdminService.createCompanyFromExample({
                        ...this.company,
                        ExampleCompanyId: item.CompanyId
                    });
                    this.displaySnackBar("Bolaget skapades från exempel");
                    this.loadCompanies();
                    window.refreshCompanies()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async copyCompany(company) {
                this.loading++;
                var idToCopy = company.CompanyId;
                var nameOfCopy = company.Name + "_kopia";

                try{
                    await AdminService.copyCompany(idToCopy, nameOfCopy);
                    this.displaySnackBar("Bolaget kopierades");
                    this.loadCompanies();
                    window.refreshCompanies()
                }
                catch(error){
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async deleteCompany(companyId) {
                if (confirm("Är du säker att du vill radera företaget?")) {
                    this.loading++;
                    try {
                        await AdminService.deleteCompany(companyId);
                        this.displaySnackBar("Bolaget togs bort");
                        this.loadCompanies();
                        window.refreshCompanies()
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async setCompanyDeleted(companyId) {
                if (confirm("Är du säker att du vill markera bolaget som raderat?")) {
                    this.loading++;
                    try {
                        await AdminService.setCompanyDeleted(companyId);
                        this.displaySnackBar("Bolaget togs bort");
                        this.loadCompanies();
                        window.refreshCompanies()
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async reactivateCompany(companyId) {
                if (confirm("Är du säker att du vill återaktivera företaget?")) {
                    this.loading++;
                    try {
                        await AdminService.setCompanyActive(companyId);
                        this.displaySnackBar("Bolaget återaktiverades");
                        window.refreshCompanies()
                        this.loadCompanies();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async loadCompanies() {
                this.loading++;
                try {
                    this.companies = await AdminService.getDepartmentCompanies(this.filter);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async updateCompany(company) {
                this.loading++;
                this.updateCompanyModal.open(company)
                this.loading--;
            },
            async loadClubs() {
                this.loading++;
                try {
                    this.clubs = await AdminService.getDepartmentClubs();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadWorkspaces(clubId) {
                this.loading++;
                try {
                    this.workspaces = await AdminService.getWorkspacesFromClub(clubId);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadUsers() {
                this.loading++;
                try {
                    this.users = await AdminService.getWorkspaceUsers();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadAvailableExampleCompanies() {
                this.loading++;
                try {
                    this.availableExampleCompanies = await AdminService.getAvailableExampleCompanies();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            getUsers() {
                return this.users;
            },
            getWorkspaces() {
                return this.workspaces;
            },
            getClubs() {
                return this.clubs;
            },
            getCompanies() {
                return this.companies;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                filter: null,
                rules: ValidationService.rules(),
                companyloaded: false,
                company: {
                    DepartmentId: 0,
                    ClubId: 0,
                    WorkspaceId: 0,
                    Name: '',
                    UserId: 0,
                },
                companies: [],
                availableExampleCompanies: [],
                copyName: null,
                users: [],
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            'company.ClubId': function (newVal) {
                this.company.WorkspaceId = null;
                this.loadWorkspaces(newVal)
            },
        },
        mounted() {
            this.loadCompanies();
            this.loadClubs();
            this.loadUsers();
            this.loadAvailableExampleCompanies();
        },
        setup() {
            return { form, updateCompanyModal }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
